import { createSelector } from 'reselect'

/**
 * Direct selector to the app state domain
 */
export const selectLocationMangerDomain = () => (state) => state.locationManager

export const selectCachedLocations = () =>
  createSelector(selectLocationMangerDomain(), (substate) => substate.locations)

export const selectIsLoadingSuggestions = () =>
  createSelector(
    selectLocationMangerDomain(),
    (substate) => substate.isLoadingSuggestions,
  )
